const component = require('./component')
const h = require('./h')
const odoql = require('../odoql/odojs')

// built in plugins
component.use(odoql)

module.exports = {
  component: component,
  dom: h,
  svg: h,
  hub: require('./hub')
}
